<div id="page-container" class="grid-container">
  <div>
    <app-asset-hierarchy [statusMode]="true" [itemsSelectable]="false"></app-asset-hierarchy>
  </div>

  <ngx-simplebar class="responsiveScrollContainer h-full">
    <div id="tenant-home-container" class="grid-container h-full">
      <div class="widget" style="grid-column: 1/6; grid-row: 1">
        <app-customer-map [rootId]="selectedAssetId"></app-customer-map>
      </div>

      <ngx-simplebar
        [options]="{ autoHide: false }"
        style="grid-row: 2"
        [options]="{ autoHide: false }"
        class="widget flex"
      >
        <app-kpi
          class="h-full w-full"
          label="tenant_home_page.customers"
          iconName="customer"
          iconColor="primary"
          [compact]="true"
          [source]="tenantPageFacade.noOfCustomers()"
        ></app-kpi>
      </ngx-simplebar>
      <ngx-simplebar [options]="{ autoHide: false }" style="grid-row: 2; grid-column: 2" class="widget flex">
        <app-kpi
          class="h-full w-full"
          label="tenant_home_page.ready_gate_systems"
          iconName="gate-0"
          iconColor="primary"
          [source]="tenantPageFacade.availableGates()"
          [compact]="true"
        ></app-kpi>
      </ngx-simplebar>
      <ngx-simplebar [options]="{ autoHide: false }" class="widget" style="grid-row: 2; grid-column: 3/5">
        @if (openFaultsConfig) {
          <app-open-notice-card [values]="tenantPageFacade.openFaults()" [config]="openFaultsConfig">
          </app-open-notice-card>
        }
      </ngx-simplebar>
      <ngx-simplebar [options]="{ autoHide: false }" class="widget" style="grid-row: 2; grid-column: 5">
        @if (openServicesConfig) {
          <app-open-notice-card [values]="tenantPageFacade.openServices()" [config]="openServicesConfig">
          </app-open-notice-card>
        }
      </ngx-simplebar>

      <ngx-simplebar id="faultList" class="widget container" [options]="{ autoHide: false }">
        <app-gate-fault-table [gateFaults]="tenantPageFacade.gateFaultState()"></app-gate-fault-table>
      </ngx-simplebar>
      <div id="repairsContainer">
        <app-repairs [compact]="true"></app-repairs>
      </div>
    </div>
  </ngx-simplebar>
</div>
